import { Observable } from "rxjs";
import { LocationGroup } from "../domain/models/location-group";
import { CreateLocationGroup } from "../domain/requests/location-group/create-location-group-request";
import { EditLocationGroup } from "../domain/requests/location-group/edit-location-group-request";
import { BaseResponse } from "../../data/shared/base.response";
import { CreateLocationGroupsForAMSRequest } from "../domain/requests/location-group/create-location-groups-for-ams-request";
import { RenameLocationGroup } from "../domain/requests/location-group/rename-location-group";

export abstract class LocationGroupRepository {

      abstract GetLocationGroupsByPlanContainerID(request: string): Observable<LocationGroup[]>;
      abstract DeleteLocationGroup(request: string): Observable<boolean>;
      abstract CreateLocationGroup(request: CreateLocationGroup): Observable<BaseResponse<string>>;
      abstract EditLocationGroup(request: EditLocationGroup): Observable<BaseResponse<boolean>>;
      abstract GetLocationsGroupById(request: string): Observable<LocationGroup>; 
      abstract CreateLocationsGroupsByAMS(request: CreateLocationGroupsForAMSRequest): Observable<BaseResponse<string>>;
      abstract UpdateLocationGroupNameById(request: RenameLocationGroup): Observable<BaseResponse<string>>;
}